@charset "UTF-8";

/* src/app/components/v2-open-spinners/v2-open-spinners.component.scss */
:host {
  display: contents;
}
body.v2-open-spinners-open {
  overflow: hidden;
}
.v2-open-spinners {
  position: fixed;
  inset: 0;
  height: 100%;
  max-height: 100dvh;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: 50% 50%;
  animation: v2-open-spinners-enter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
  background: var(--exme-overlay-atmosphere-background);
}
.v2-open-spinners.v2-open-spinners--closing {
  pointer-events: none;
  animation: v2-open-spinners-exit 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes v2-open-spinners-enter {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes v2-open-spinners-exit {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-open-spinners {
    animation: none;
  }
  .v2-open-spinners.v2-open-spinners--closing {
    animation: none;
    opacity: 0;
  }
}
.v2-os-spinner-pack-layer {
  position: absolute;
  inset: 0;
  z-index: 28;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  background: var(--exme-overlay-atmosphere-background);
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
}
.v2-os-spinner-pack-frame {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  max-width: min(100vw, 420px);
  transform-origin: center center;
  will-change: transform, opacity;
  transition: filter 0.12s ease;
}
.v2-os-spinner-pack-frame--open-request {
  filter: brightness(1.06) saturate(1.05);
  pointer-events: none;
}
@media (prefers-reduced-motion: no-preference) {
  .v2-os-spinner-pack-frame {
    animation: v2-os-spinner-pack-intro 0.82s cubic-bezier(0.34, 1.45, 0.64, 1) both;
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-os-spinner-pack-frame {
    animation: none;
  }
}
@keyframes v2-os-spinner-pack-intro {
  from {
    opacity: 0;
    transform: translate3d(0, min(48vh, 520px), 0) scale(0.44);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
.v2-os-spinner-stage--pack {
  margin: 0;
  width: 100%;
  min-height: min(40vh, 300px);
}
.v2-open-spinners .v2-os-tap-hint {
  position: absolute;
  left: 50%;
  bottom: calc(1.25rem + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  z-index: 61;
  margin: 0;
  padding: 0.5rem 0.9rem;
  max-width: min(92vw, 360px);
  text-align: center;
  font-size: 0.9rem;
  line-height: 1.35;
  color: rgba(13, 18, 24, 0.88);
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.45);
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.55s ease;
}
body.dark .v2-open-spinners .v2-os-tap-hint {
  color: rgba(255, 255, 255, 0.88);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}
.v2-open-spinners .v2-os-tap-hint--hide {
  opacity: 0;
  pointer-events: none;
}
.v2-open-spinners .v2-os-tap-hint--stacked {
  bottom: calc(5.25rem + env(safe-area-inset-bottom));
}
.v2-os-spinner-pack-actions {
  position: absolute;
  left: 50%;
  bottom: calc(1.1rem + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  z-index: 62;
  width: min(92vw, 360px);
  max-width: 100%;
  padding: 0 env(safe-area-inset-left) 0 env(safe-area-inset-right);
  box-sizing: border-box;
  pointer-events: auto;
}
.v2-os-spinner-pack-actions .btn-wrapper {
  width: 100%;
}
.v2-os-spinner-pack-actions__inner {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
  gap: 0.55rem;
}
.v2-open-spinners .v2-rpc-floating-close {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
body.dark .v2-open-spinners .v2-rpc-floating-close {
  background: rgba(22, 28, 36, 0.9);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}
.v2-open-spinners .v2-rpc-title-pill {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(13, 18, 24, 0.07);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
body.dark .v2-open-spinners .v2-rpc-title-pill {
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
}
.v2-open-spinners .v2-os-title-pill {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  flex-wrap: wrap;
}
.v2-open-spinners .v2-os-title-pill__text {
  min-width: 0;
}
.v2-open-spinners .v2-os-title-pill__badge {
  flex-shrink: 0;
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
  color: var(--ion-color-primary-contrast, #fff);
  background: var(--ion-color-primary);
  border-radius: 999px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.14);
}
body.dark .v2-open-spinners .v2-os-title-pill__badge {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
}
.v2-open-spinners .manage-wrapper.v2-req-phys-wrap.v2-os-wrap .v2-rpc-item {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.07) !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
body.dark .v2-open-spinners .manage-wrapper.v2-req-phys-wrap.v2-os-wrap .v2-rpc-item {
  background: rgba(22, 28, 36, 0.7);
  border-color: rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.25);
}
.v2-open-spinners-rpc-progress {
  position: fixed;
  top: 3.35rem;
  left: 50%;
  transform: translateX(-50%);
  width: min(220px, 70vw);
  z-index: 62;
  pointer-events: none;
}
.v2-open-spinners-rpc-progress ion-progress-bar,
.v2-open-spinners-progress {
  height: 3px;
  border-radius: 999px;
  overflow: hidden;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap {
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap main.v2-rpc-scroll > * {
  opacity: 0;
  transform: scale(0.9) translateY(-40px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap main.v2-rpc-scroll > .v2-os-skeleton-panel {
  opacity: 1;
  transform: none;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > * {
  opacity: 1;
  transform: scale(1) translateY(0);
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(1) {
  transition-delay: 0.35s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(2) {
  transition-delay: 0.5s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(3) {
  transition-delay: 0.65s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(4) {
  transition-delay: 0.8s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(5) {
  transition-delay: 0.95s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(6) {
  transition-delay: 1.1s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(7) {
  transition-delay: 1.25s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(8) {
  transition-delay: 1.4s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(9) {
  transition-delay: 1.55s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(10) {
  transition-delay: 1.7s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(11) {
  transition-delay: 1.85s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(12) {
  transition-delay: 2s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(13) {
  transition-delay: 2.15s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(14) {
  transition-delay: 2.3s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(15) {
  transition-delay: 2.45s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > *:nth-child(16) {
  transition-delay: 2.6s;
}
@media (prefers-reduced-motion: reduce) {
  .manage-wrapper.v2-req-phys-wrap.v2-os-wrap main.v2-rpc-scroll > * {
    opacity: 1;
    transform: none;
    transition: opacity 0.2s ease;
  }
  .manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded main.v2-rpc-scroll > * {
    transition-delay: 0s !important;
  }
  .manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn,
  .manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-single-open {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}
.v2-os-panel {
  background: var(--ion-color-primary-low);
  border-radius: 18px;
  padding: clamp(1rem, 4vw, 1.35rem);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}
.v2-os-panel--top {
  padding: clamp(1rem, 3vw, 1.25rem);
}
.v2-req-phys-wrap .v2-rpc-item > .v2-os-panel {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0;
  padding: 0;
}
.v2-req-phys-wrap .v2-rpc-item > .v2-os-panel.v2-os-panel--top {
  padding: 0;
}
.v2-os-top-section {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: clamp(0.5rem, 2.5vw, 1.2rem);
  min-width: 0;
}
.v2-os-collection-image {
  flex: 0 0 auto;
  width: 140px;
  height: 140px;
}
@media (max-width: 420px) {
  .v2-os-collection-image {
    width: 120px;
    height: 120px;
  }
}
@media (max-width: 380px) {
  .v2-os-collection-image {
    width: 100px;
    height: 100px;
  }
}
.v2-os-empty-rpc-icon {
  display: flex;
  justify-content: center;
  padding: 0.15rem 0 0.35rem;
}
.v2-os-image-frame {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: var(--ion-color-primary-low);
  border: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
}
.v2-os-image-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background:
    linear-gradient(
      135deg,
      var(--ion-color-step-100, #f0f0f0) 0%,
      var(--ion-color-step-150, #e8e8e8) 100%);
  border: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.v2-os-image-frame.v2-os-empty-rpc-icon__frame,
.v2-os-image-placeholder.v2-os-empty-rpc-icon__frame {
  width: 112px;
  height: 112px;
  flex-shrink: 0;
}
.v2-os-stats-side {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  gap: 0.45rem;
}
.v2-os-metric {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.35rem;
  align-self: flex-start;
  max-width: 100%;
  min-width: 0;
  padding: 0.4rem 0.55rem;
  border-radius: 999px;
  background: var(--ion-color-primary-medium);
  border: 1px solid var(--ion-color-step-100, rgba(0, 0, 0, 0.06));
  width: 100%;
}
.v2-os-metric-label {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--ion-color-text);
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 400px) {
  .v2-os-metric-label {
    font-size: 0.72rem;
  }
  .v2-os-metric {
    gap: 0.5rem;
    padding: 0.45rem 0.75rem;
  }
}
.v2-os-metric-value {
  flex-shrink: 0;
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1;
  color: var(--ion-color-primary);
  font-variant-numeric: tabular-nums;
}
@media (min-width: 400px) {
  .v2-os-metric-value {
    font-size: 1.2rem;
  }
}
.v2-os-metric--zero .v2-os-metric-value {
  color: var(--ion-color-text);
}
.v2-os-collection-title {
  margin: 0 0 0.15rem;
  font-size: clamp(0.95rem, 3.5vw, 1.1rem);
  font-weight: 700;
  line-height: 1.25;
  color: var(--ion-color-text);
  word-break: break-word;
  overflow-wrap: anywhere;
  max-width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-align: center;
}
.v2-os-meta {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--ion-color-text);
  max-width: 100%;
}
.v2-os-body {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--ion-color-text);
  max-width: 36rem;
  margin-inline: auto;
}
.v2-os-copy-block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.v2-os-section-label {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--ion-color-text);
  max-width: 36rem;
  margin-inline: auto;
}
.v2-os-count-column {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
}
@keyframes v2-os-option-in {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.v2-os-count-column > app-btn {
  display: block;
  opacity: 0;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn {
  animation: v2-os-option-in 0.5s ease forwards;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn:nth-child(1) {
  animation-delay: 0.35s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn:nth-child(2) {
  animation-delay: 0.5s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn:nth-child(3) {
  animation-delay: 0.65s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn:nth-child(4) {
  animation-delay: 0.8s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn:nth-child(5) {
  animation-delay: 0.95s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn:nth-child(6) {
  animation-delay: 1.1s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn:nth-child(7) {
  animation-delay: 1.25s;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-count-column > app-btn:nth-child(8) {
  animation-delay: 1.4s;
}
.v2-os-single-open {
  display: block;
  opacity: 0;
}
.manage-wrapper.v2-req-phys-wrap.v2-os-wrap.opened.loaded .v2-os-single-open {
  animation: v2-os-option-in 0.5s ease forwards;
  animation-delay: 0.35s;
}
.v2-os-helper {
  margin: 0.35rem 0 0;
  padding: 0 0.25rem;
  text-align: center;
  font-size: 0.86rem;
  line-height: 1.45;
  color: var(--ion-color-text);
  max-width: 22rem;
  margin-inline: auto;
}
.v2-os-count-column .btn-wrapper {
  width: 100%;
}
.v2-os-count-column .btn-wrapper .btn {
  min-height: 48px;
  padding: 0.72rem 0.85rem;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.2;
  border-radius: 14px;
  text-align: center;
}
.v2-os-secondary-actions {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-top: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ion-color-step-100, rgba(0, 0, 0, 0.08));
}
.v2-os-eyebrow {
  margin: 0 0 0.15rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ion-color-text);
  line-height: 1.3;
}
.v2-req-phys-wrap .v2-rpc-item .v2-os-empty-rpc__secondary {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}
.v2-os-spinner-stage-rpc {
  overflow: visible;
}
ion-img.v2-os-hero-img {
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.35s ease-in-out;
}
ion-img.v2-os-hero-img.fade {
  opacity: 1;
}
ion-img.v2-os-hero-img::part(image) {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.v2-open-spinners {
  --v2-os-shimmer-base-rgb: var(--ion-background-color-rgb, 235, 235, 235);
  --v2-os-shimmer-highlight-rgb: var(--ion-color-step-100, 250, 250, 250);
}
body.dark .v2-open-spinners {
  --v2-os-shimmer-base-rgb:
    40,
    40,
    40;
  --v2-os-shimmer-highlight-rgb:
    70,
    70,
    70;
}
.v2-os-img-shimmer {
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;
  background-image:
    linear-gradient(
      90deg,
      rgba(var(--v2-os-shimmer-base-rgb), 0.35) 0%,
      rgba(var(--v2-os-shimmer-highlight-rgb), 0.55) 45%,
      rgba(var(--v2-os-shimmer-highlight-rgb), 0.75) 50%,
      rgba(var(--v2-os-shimmer-highlight-rgb), 0.55) 55%,
      rgba(var(--v2-os-shimmer-base-rgb), 0.35) 100%);
  background-size: 220% 100%;
  animation: v2-os-img-shimmer 1.7s infinite cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes v2-os-img-shimmer {
  0% {
    background-position: 180% 0;
  }
  100% {
    background-position: -180% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-os-img-shimmer {
    animation: none;
    opacity: 0.85;
  }
}
.v2-os-skeleton-panel {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  padding: 0.5rem 0 1.5rem;
  min-height: 220px;
}
.v2-os-skeleton-top-row {
  display: flex;
  gap: 1.2rem;
  align-items: stretch;
}
.v2-os-skeleton-stats {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  justify-content: center;
  min-width: 0;
}
.v2-os-skeleton-hero {
  flex-shrink: 0;
  width: 140px;
  height: 140px;
  border-radius: 16px;
  background:
    linear-gradient(
      90deg,
      var(--ion-color-step-150, #e8e8e8) 0%,
      var(--ion-color-step-100, #f0f0f0) 50%,
      var(--ion-color-step-150, #e8e8e8) 100%);
  background-size: 200% 100%;
  animation: v2-os-shimmer 1.2s ease-in-out infinite;
}
@media (max-width: 420px) {
  .v2-os-skeleton-hero {
    width: 120px;
    height: 120px;
  }
}
.v2-os-skeleton-line {
  height: 14px;
  border-radius: 8px;
  max-width: 100%;
  background: var(--ion-color-step-150, #e8e8e8);
  animation: v2-os-shimmer 1.2s ease-in-out infinite;
}
.v2-os-skeleton-line--short {
  max-width: 65%;
}
.v2-os-skeleton-line--medium {
  max-width: 85%;
}
.v2-os-skeleton-actions {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: 100%;
}
.v2-os-skeleton-btn-bar {
  width: 100%;
  height: 48px;
  border-radius: 14px;
  background: var(--ion-color-step-150, #e8e8e8);
  animation: v2-os-shimmer 1.2s ease-in-out infinite;
}
.v2-os-skeleton-btn-bar--short {
  width: 72%;
  max-width: 280px;
}
.v2-os-loading-caption {
  margin: 0.5rem 0 0;
  text-align: center;
  font-size: 0.9rem;
  color: var(--ion-color-text);
}
@keyframes v2-os-shimmer {
  0% {
    opacity: 0.65;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.65;
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-os-skeleton-hero,
  .v2-os-skeleton-line,
  .v2-os-skeleton-btn-bar {
    animation: none;
    opacity: 0.85;
  }
}
.v2-open-spinners .btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 3px;
}
.sc-ion-label-md-s > p {
  color: var(--ion-color-text-87);
}
.v2-os-section-title {
  margin: 0 0 0.35rem;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  color: var(--ion-color-text);
}
.v2-os-body--center {
  text-align: center;
}
.v2-os-spinner-stage {
  position: relative;
  width: 100%;
  min-height: 300px;
  margin: 0.25rem 0 0.75rem;
}
.v2-os-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 320px;
  margin-inline: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  min-height: 240px;
  pointer-events: none;
}
.v2-os-spinner-container--open {
  pointer-events: auto;
  cursor: pointer;
  z-index: 6;
}
@media (prefers-reduced-motion: reduce) {
  .v2-os-spinner-container--open {
    cursor: default;
  }
}
/*# sourceMappingURL=v2-open-spinners.component.css.map */
